import { useRef, useState } from 'react'

import { MyOptionType } from '@procsea/design-system'

import { useCurrentVertical } from 'src/hooks'
import { useRequestableProductsQuery } from 'src/queries/seller/requestableProducts'
import { RequestableProduct } from 'src/types'

export interface AsyncRequestableProductOptionType
  extends MyOptionType<MyOptionType<RequestableProduct>> {
  latinName: string
}

export const getRequestableProductOption = (
  requestableProduct: RequestableProduct
): AsyncRequestableProductOptionType => ({
  label: requestableProduct.name,
  value: {
    label: requestableProduct.name,
    value: requestableProduct,
  },
  latinName: requestableProduct.latinName,
})

const useAsyncRequestableProductOptions = () => {
  const resolveQueryRef = useRef<(options: AsyncRequestableProductOptionType[]) => void>(() => {})
  const rejectQueryRef = useRef<(error: Error) => void>(() => {})

  const [query, setQuery] = useState<string>()

  const verticalId = useCurrentVertical()?.id

  useRequestableProductsQuery({
    queryOptions: {
      staleTime: 0,
      enabled: !!query && !!verticalId,
      onError: rejectQueryRef.current,
      onSuccess: resolveQueryRef.current,
      select: response => response.map(getRequestableProductOption),
    },
    queryParams: { name: query, verticalId, ordering: 'name' },
  })

  const searchForQuery = (search: string) =>
    new Promise<AsyncRequestableProductOptionType[]>((resolve, reject) => {
      resolveQueryRef.current = resolve
      rejectQueryRef.current = reject
      setQuery(search)
    })

  return { searchForQuery }
}

export default useAsyncRequestableProductOptions
